import { render, staticRenderFns } from "./knowledgesearch.vue?vue&type=template&id=539a6c4b&scoped=true"
import script from "./knowledgesearch.vue?vue&type=script&lang=js"
export * from "./knowledgesearch.vue?vue&type=script&lang=js"
import style0 from "./knowledgesearch.vue?vue&type=style&index=0&id=539a6c4b&prod&lang=scss"
import style1 from "./knowledgesearch.vue?vue&type=style&index=1&id=539a6c4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539a6c4b",
  null
  
)

export default component.exports